import { render, staticRenderFns } from "./ItemTemplate2.vue?vue&type=template&id=43e66625&scoped=true&"
import script from "./ItemTemplate2.vue?vue&type=script&lang=js&"
export * from "./ItemTemplate2.vue?vue&type=script&lang=js&"
import style0 from "./ItemTemplate2.vue?vue&type=style&index=0&id=43e66625&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e66625",
  null
  
)

export default component.exports